export const FETCH_CLIENTS_REQUEST = 'FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE = 'FETCH_CLIENTS_FAILURE';

export const UPDATE_CLIENT_STATUS_REQUEST = 'UPDATE_CLIENT_STATUS_REQUEST';
export const UPDATE_CLIENT_STATUS_SUCCESS = 'UPDATE_CLIENT_STATUS_SUCCESS';
export const UPDATE_CLIENT_STATUS_FAILURE = 'UPDATE_CLIENT_STATUS_FAILURE';
